// import axios from "axios";
import secure_axios from "../../services/secure_axios";

const initialState =()=> ({
  salespersons: [],
  salesperson: {},
});
const state = initialState();
const getters = {
    salespersons: (state) => state.salespersons,
    salesperson: (state) => state.salesperson,
};

const mutations = {
  setSalesPersons(state, payload) {
    state.salespersons = payload;
  },
  setSalesPerson(state, payload) {
    state.salesperson = payload;
  },
  RESET_STATE(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
};

const actions = {
  getSalesPersons({ commit, getters }, payload) {
    commit("setLoading", true);
    commit("clearError");

    const smandocno = payload.smandocno;
    const url= getters.sessionAPI;
    if (url&&smandocno){    
      secure_axios
      .get(`${url}salespersons?smandocno=${smandocno}`)
      .then((response) => {
        commit("setSalesPersons", response.data.salespersons);
        commit("setLoading", false);
      })
      .catch((error) => {
        
        commit("setError", error);
      });
    }
    commit("setLoading", false);
  },

  getSalesPerson({ commit }, payload) {
    commit("setLoading", true);
    commit("clearError");

    const smandocno = payload.smandocno;

    commit("setSalesPerson", smandocno)
    commit("setLoading", false);
  },

};

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
};
